import React from 'react';

import { config } from 'src/config';

export const getVariableValue = (variable: string, variablesMap?: Record<string, React.ReactNode>) => {
  const value = variablesMap && variablesMap[variable];

  if (!value) {
    if (config.ENV === 'development') {
      throw new Error(`Could not render Portable Text Component. Variable with name '${variable}' does not exist.`);
    }

    return `{${variable}}`;
  }

  return value;
};
